<template>
  <div>
    <AddFormItem
      :bp="bp"
      :fields="fields"
      :custom_icon="custom_icon"
      @submit="submit_action"
    />
  </div>
</template>
  
<script>
  import AddFormItem from '@/components/bpcreator/model/AddFormItem';
  export default {
    components: {
      AddFormItem
    },
      
    name: 'AddRole',
      
    props: {
      bp: {default: () => ({})},
      field: {default: () => ({})},
      custom_icon: {default: 'mdi-plus'},
      roles: {default: ()=>({})},
    },
      
    data: () => ({
    }),
      
    computed: {
      fields() {
        let res = []
        for (let item of this.bp.new_role_property().props) {
          res.push([
          {
            ...item,
            'cols': 4,
            'value': item && item.value_funct ? (item.value_funct)(this.field,this.bp.lang) : (this.field || {})[item.id],
          }

          ])
        }
        return res;
      }
    },
      
    methods: {
      submit_action(values) {
        this.$emit('submit',{...this.field,values});
      },
    },
  }
</script>